import { render } from "./uni_button.vue?vue&type=template&id=ce179422"
import script from "./uni_button.vue?vue&type=script&lang=js"
export * from "./uni_button.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__